import React from 'react';
import { titleize } from 'inflection';

import styles from './featuredIdeasListStyles';

import Link from 'buyside/components/presentation/Link/link';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';

import { ideaUrl, userUrl, defaultUserImageUrl } from 'buyside/util/urlHelper';

const FeaturedIdeasListItem = ({ idea, idx, handleClick, showUserDetails }) => {
  let companyName = '';
  const {
    id,
    user: { id: userId, profile, profileImageUrl, displayName, mostRecentEmployer },
    positions
  } = idea;
  if (profile.companyString) companyName = ` (${profile.companyString})`;
  const isRedacted = positions[0].entityName === 'Redacted';
  return (
    <div className={styles.featuredIdeasListItem}>
      <span className={styles.featuredIdeasListNumber}>{idx + 1}.</span>
      <span className={styles.featuredIdeasListItemIdea}>
        {isRedacted ? (
          <RedactedDataPoint Wrapper="div" />
        ) : (
          <Link to={ideaUrl(id)} onClick={handleClick}>
            {positions.map(({ id, entityName, primarySymbol }) => (
              <div key={id}>
                {titleize(entityName)} ({primarySymbol})
              </div>
            ))}
          </Link>
        )}
      </span>
      <span className={styles.featuredIdeasListItemUser}>
        <ProfileImage
          source={showUserDetails ? profileImageUrl : defaultUserImageUrl()}
          size="tiny"
        />
        {showUserDetails ? (
          <Link to={userUrl(userId)}>{`${displayName}${companyName}`}</Link>
        ) : (
          <AnonymousUserDisplay
            anonUser={{ title: mostRecentEmployer && mostRecentEmployer.title }}
          />
        )}
      </span>
    </div>
  );
};

export default FeaturedIdeasListItem;
